import React, { useEffect, useState } from 'react'
import { Alert, Box, CircularProgress, styled } from '@mui/material'
import SearchBarInput from '../master/components/SearchBarInput';
import MasterAppBar from '../master/components/MasterAppBar'
import CourseCard from '../dashbord/components/CourseCard';
import Footer from '../master/components/Footer';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { useAuthContext } from '../auth/hooks/useAuthContext';
import { fetchCourses } from '../../services/desktopData';

function MyCourses() {
    const { user } = useAuthContext();
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        fetchCourses(user)
            .then((items) => active && setCourses(items))
            .catch((requestError) => active && setError(requestError.response?.data?.message || requestError.message))
            .finally(() => active && setLoading(false));
        return () => { active = false; };
    }, [user]);

    const CoursesBox = styled(Box)(({ theme }) => ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '90vw',
        gap: '20px',
        margin: 'auto',
        marginTop: '4rem'

    }))
    return (
        <ScopedCssBaseline>
            <Box>
                <MasterAppBar crumb={true} />
                <SearchBarInput />
                <CoursesBox>
                    {loading && <CircularProgress />}
                    {!loading && error && <Alert severity="error" sx={{ width: '100%' }}>{error}</Alert>}
                    {courses.map(course => (
                        <CourseCard key={course.id} data={course} />
                    ))}
                </CoursesBox>
                <Footer />
            </Box>
        </ScopedCssBaseline>

    )
}

export default MyCourses
